import React from 'react';
import styled from 'styled-components';

import { ProfileAvatar, ProfilePictureProps } from '../profile-avatar/ProfileAvatar';

type SettingsAvatarProps = {
  title: string;
  detail: string;
} & ProfilePictureProps;

export const SettingsAvatar: React.FC<SettingsAvatarProps> = ({ detail, title, ...props }) => (
  <Container>
    <Header>
      <h3>{title}</h3>
      <Detail>{detail}</Detail>
    </Header>

    <Wrapper>
      <ProfileAvatar {...props} />
    </Wrapper>
  </Container>
);

const Container = styled.div`
  width: 100%;
  border-radius: var(--border-radius-medium);
  border: 1.5px dashed var(--color-secondary);
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 1.6rem;
  align-items: center;
  margin-bottom: 0.8rem;
`;

const Detail = styled.p`
  font-size: 1.2rem;
  text-align: right;
  color: var(--color-grayscale-light-slate);
`;

const Wrapper = styled.div`
  flex: 1;
  max-height: calc(100% - 4.8rem);

  img {
    object-fit: contain;
  }
`;
